import Episodic from './episodic.entity';
import Account from '../accounts/account.entity';
import CmPermission from '../cm-permissions/cm-permission.entity';
import { DEPARTMENTS } from '../enums/enums';
import EpisodicFlag from '../episodic-flags/episodic-flag.entity';
import HaPermission from '../ha-permissions/ha-permission.entity';
import MuPermission from '../mu-permissions/mu-permission.entity';
import PrPermission from '../pr-permissions/pr-permission.entity';
import Production from '../productions/production.entity';
import SetPermission from '../set-permissions/set-permission.entity';
import {
	SosListResponse,
	SosUpdateResponse,
	SosDeleteResponse,
	SosCreateResponse,
} from '../sos-response';

export interface EpisodicUpdateResponse extends SosUpdateResponse {
	updated: {
		Episodic: Episodic[];
	};
}

export interface EpisodicUpdateTitlesResponse extends SosUpdateResponse {
	updated: {
		Episodic: Episodic[];
		Production: Production[];
	};
}

export interface EpisodicUpdateCharMergeResponse
	extends SosCreateResponse,
		SosDeleteResponse {
	created: {
		EpisodicFlag: EpisodicFlag[];
	};
	destroyed: {
		EpisodicFlag: EpisodicFlag[];
	};
}

export interface EpisodicGetResponse extends SosListResponse {
	listed: {
		Episodic: Episodic[];
		Account: Account[];
		EpisodicFlag?: EpisodicFlag[];
	};
}

export interface EpisodicGetDeptPermsResponse extends SosListResponse {
	listed: {
		CmPermission: CmPermission[];
		HaPermission: HaPermission[];
		MuPermission: MuPermission[];
		SetPermission: SetPermission[];
		PrPermission: PrPermission[];
	};
}

export interface EpisodicGetPictureCountResponse {
	listed: {
		pictureCountsByDept: {
			[DEPARTMENTS.CM]: number;
			[DEPARTMENTS.HA]: number;
			[DEPARTMENTS.MU]: number;
			[DEPARTMENTS.PR]: number;
			[DEPARTMENTS.SET]: number;
		};
	};
}

export interface EpisodicListSeasonsResponse extends SosListResponse {
	listed: {
		Episodic: Episodic[];
	};
}
